const SpotIndex = () => import("@/views/other/spot/SpotIndex.vue")

const routes = [
    {
        path: "/admin/spots",
        name: "Spots",
        component: SpotIndex,
        meta: {
            label: "Spots"
        }
    }
]

export default routes
